import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/Terms.css';

function Terms() {
  return (
    <div className="terms-page">
      {/* Header */}
      <div className="terms-header" style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
        <img
          src="/clustrops-logo.png"
          alt="ClustrOps"
          style={{ height: 180, objectFit: 'contain' }}
        />
      </div>

      {/* Title */}
      <h1 className="terms-title">Terms & Conditions</h1>

      {/* Content */}
      <div className="terms-content">
        <p>
         <strong> Welcome to ClustrOps. By using this platform, you agree to comply with the following terms and conditions:</strong>
        </p>
        <ol>
          <li>You must provide accurate and truthful information during registration.</li>
          <li>Unauthorized access, sharing, or misuse of user accounts is strictly prohibited.</li>
          <li>Your data will be handled according to our Privacy Policy.</li>
          <li>ClustrOps may update these terms at any time; continued use constitutes acceptance.</li>
          <li>Use of this platform must comply with applicable laws and regulations.</li>
        </ol>
        <p>
          For any questions, please contact <a href="mailto:support@clusterops.in">support@clusterops.in</a>.
        </p>
      </div>

      {/* Back link */}
      <div className="back-link">
        <Link to="/register">← Back to Registration</Link>
      </div>
    </div>
  );
}

export default Terms;
